import {Col, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import React, {useEffect, useState} from "react";
import FcltyFloorList from "./FcltyFloorList";
import PopUp from "../popUp/PopUp";
import FcltyFloorAdd from "../../pages/subPages/FcltyFloorAdd";
import {putCMFWFloorOrder} from "../../api/apiClient";
import Swal from "sweetalert2";


const FcltyFloorSelectorV2 = ({
                                propFcltyID,
                                propFcltyFloorList,
                                propSetFlctyFloorList,
                                propSelectedFloorIdx,
                                setSelectedFloorIdx,
                                propIsReadOnly,
                                updateList,
                                propLocation
                              }) => {

  const handleFloorBtnClick = (e, idx) => {
    setSelectedFloorIdx(idx);
  };

  // const onChangeFloorName = (e, idx) => {
  //   e.preventDefault();
  //   console.log(e.target.value, idx);
  //   propSetFlctyFloorList(prev => {
  //     return prev.map((item, i) => {
  //       if (i === idx) {
  //         return {
  //           ...item,
  //           fclty_dtl_nm: e.target.value
  //         }
  //       } else {
  //         return item;
  //       }
  //     });
  //   });
  // };

  const [stPopupOption, setPopupOption] = useState({
    isVisible: false,
    fcltyNo: 0,
    fcltyDtlNo: 0,
    fcltyDtlNm: "",
    isNew: true
  });

  const handleOpenLayer = (e, is_new = false, dtl_no, dtl_nm) => {
    setPopupOption(prev => {
      return {
        ...prev,
        isVisible: true,
        fcltyNo: e.target.dataset.id,
        isNew: is_new,
        fcltyDtlNo: is_new ? 0 : dtl_no,
        fcltyDtlNm: is_new ? "" : dtl_nm,
      };
    })
  };

  const setPopupClose = () => {
    setPopupOption(prev => {
      return {
        ...prev,
        isVisible: false
      }
    });
    updateList();
  }

  const [isFloorChanged, setIsFloorChanged] = useState(false);

  const submitFloorInfo = (e) => {
    const submitData = [];
    propFcltyFloorList.forEach((item, idx) => {
      submitData.push({
        fcltyDtlNo: item.fclty_dtl_no,
        fcltyDtlSn: idx + 1
      });
    });

    console.log(submitData);

    putCMFWFloorOrder(submitData)
        .then(res => {
          if (res.status === 200) {
            Swal.fire(
                '정상적으로 처리 되었습니다!',
                '',
                'success'
            );
          }
        })
        .catch(err => {
          Swal.fire(
              err.response.data.message,
              '',
              'error'
          );
        });
  }

  return (
      <>
        <PopUp
            propShow={stPopupOption.isVisible}
            setShow={setPopupClose}
            propTitle={stPopupOption.isNew ? "층 추가등록" : "층 수정"}
            propSize={'lg'}
        >
          <FcltyFloorAdd
              propFcltyID={propFcltyID}
              propIsReg={stPopupOption.isNew}
              propDtlNm={stPopupOption.fcltyDtlNm}
              propDtlNo={stPopupOption.fcltyDtlNo}
              hClose={setPopupClose}
          />
        </PopUp>
        <div className={'floor-control align-middle text-center'}>
          <Row className={'p-0 justify-content-center'}>
            <Row className={"fclty-floor-list"}>
              <FcltyFloorList
                  propFcltyFloorList={propFcltyFloorList}
                  propSetFlctyFloorList={propSetFlctyFloorList}
                  propSelectedFloorIdx={propSelectedFloorIdx}
                  propSetSelectedFloorIdx={setSelectedFloorIdx}
                  propHandleFloorBtnClick={handleFloorBtnClick}
                  // propOnChangeFloorName={onChangeFloorName}
                  propHandleOpenPopup={handleOpenLayer}
                  propIsReadOnly={propIsReadOnly}
                  updateList={updateList}
                  propSetIsFloorChanged={setIsFloorChanged}
              />
            </Row>
          </Row>
        </div>
        <div className={"fclty-floor-ctl"}>
          {(propIsReadOnly) ? '' :
              <Row className={"justify-content-evenly"}>
                <Col md={3}>
                  <Button
                      className={'floor-plan-save w-100 py-2'}
                      onClick={(e) => {
                        handleOpenLayer(e, true);
                      }}>
                    층 추가
                  </Button>
                </Col>
                <Col md={4}>
                  <Button
                      className={'floor-plan-save w-100 py-2'}
                      disabled={!isFloorChanged}
                      onClick={(e) => {
                        submitFloorInfo(e);
                      }}>
                    층 순서 저장
                  </Button>
                </Col>
              </Row>}
        </div>
      </>
  );
}


export default FcltyFloorSelectorV2;